import React from 'react'
import cloudinaryVideoUrl, {
  DEVICE_TYPE,
} from '@scentregroup/ui/tools/cloudinary/video'

interface VideoProps {
  url: string
  wide?: boolean
}

export const Video: React.FC<VideoProps> = ({ url, wide }): JSX.Element => {
  const deviceType = wide === true ? DEVICE_TYPE.wide : DEVICE_TYPE.square
  const source = cloudinaryVideoUrl({
    contentfulUrl: url,
    removeAudio: true,
    deviceType,
  })

  return (
    <video playsInline autoPlay loop muted controls={false}>
      <source type="video/mp4" src={source} />
    </video>
  )
}
